import '@soopkr-fe/soop-i18n/notification';

import { createI18n } from '@soopkr-fe/soop-i18n';

const i18n = createI18n();

export const NotificationT = i18n.t;
export const NotificationI18n = i18n;
